import { create } from 'zustand';
import { IDropDownItems } from '../../../core/components/molecules/DropDownList';
import { IPAContent, TPAContentType } from '../model/dailySchedule';

interface IDailyScheduleContentState {
  contentListFilter: TPAContentType;
  setContentListFilter: (filter: TPAContentType) => void;

  contentList: IPAContent[];
  selectedContent: IPAContent | null;
  setSelectedContent: (content: IPAContent | null) => void;
  setContentList: (list: IPAContent[]) => void;

  selectedDay: IDropDownItems | null;
  setSelectedDay: (day: IDropDownItems | null) => void;

  selectedDiscipline: string;
  setSelectedDiscipline: (discipline: string) => void;

  selectedWeek: number;
  setSelectedWeek: (week: number) => void;

  isLoadingContentList: boolean;
  setIsLoadingContentList: (isLoading: boolean) => void;
}

export const useDailyScheduleContentStore = create<IDailyScheduleContentState>(
  (set) => ({
    contentListFilter: 'lesson',
    setContentListFilter: (filter: TPAContentType) =>
      set({ contentListFilter: filter }),

    contentList: [],
    selectedContent: null,
    setContentList: (list: IPAContent[]) => set({ contentList: list }),
    setSelectedContent: (content: IPAContent | null) =>
      set({ selectedContent: content }),

    selectedDay: null,
    setSelectedDay: (day: IDropDownItems | null) => set({ selectedDay: day }),
    selectedDiscipline: '',
    setSelectedDiscipline: (discipline: string) =>
      set({ selectedDiscipline: discipline }),

    selectedWeek: 1,
    setSelectedWeek: (week: number) => set({ selectedWeek: week }),
    
    isLoadingContentList: false,
    setIsLoadingContentList: (isLoading: boolean) =>
      set({ isLoadingContentList: isLoading }),
  })
);
